import MarketToday from '../../../../common/src/sections/home/MarketToday';

const DailyMarketPage = () => {
  return (
    <div className=''>
      <MarketToday />
    </div>
  );
};

export default DailyMarketPage;
